import { Grid, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BillHistory from './BillHistory';
import TransactionHistory from './TransactionHistory';
import UsageHistory from './UsageHistory';
import { getColors } from '../Shared/Functions';

export default function History ({account}) {
    const [selectedTab, setSelectedTab] = useState<any>(0);
    let [secondary, setSecondary] = useState<any>("white");
    let [tertiary, setTertiary] = useState<any>("#424449");

    useEffect(() => {
        getColors().then((x: any) => {
            setSecondary(x.secondary)
            setTertiary(x.tertiary)
        });
    }, [])

    const handleChange = (e, tab) => {
        if(typeof(tab) === 'object') {
            return;
        }
        setSelectedTab(tab)
    }

    return (<Grid className='history-container' style={{ backgroundColor: "white" }}>
            <Grid container id="history-tabs" xs={12} style={{ backgroundColor: secondary}}>
                <div style={{width:"100%"}}>
                    <Tabs value={selectedTab} onChange={handleChange} centered={false} TabIndicatorProps={{ style: { display: "none" } }}>
                        <Tab style={selectedTab === 0 ? {backgroundColor: tertiary, color:"white"} : {}} label={"Billing"} value={0} />
                        <Tab style={selectedTab === 1 ? {backgroundColor: tertiary, color:"white"} : {}} label={"Payments"} value={1} />
                        <Tab style={selectedTab === 2 ? {backgroundColor: tertiary, color:"white"} : {}} label={"Usage"} value={2} />
                    </Tabs>
                </div>
            </Grid>
            {selectedTab === 0 &&
                <BillHistory account={account} />
            }
            {selectedTab === 1 &&
                <TransactionHistory account={account} />
            }
            {selectedTab === 2 &&
                <UsageHistory account={account} />
            }
        </Grid>
    );
}